import React, { useState, useRef, useEffect } from 'react';
import Alignment from './Alignment';
import Arrangement from './Arrangement';
import { Dropdown, Button } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import './Position.css';

const Position = props => {
  const { t } = useTranslation();

  let arrangement;
  let alignment;

  if (!props.arrangement && !props.alignment) {
    arrangement = true;
    alignment = true;
  } else {
    arrangement = props.arrangement;
    alignment = props.alignment;
  }

  const [isMobile, setIsMobile] = useState(false);
  const [showItems, setShowItems] = useState(false);
  const [positionDD, setPositionDD] = useState(false);
  useEffect(() => {
    if (window.innerWidth < 650) {
      setIsMobile(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (isMobile) {
      if (positionDD) {
        // document.getElementById('workplace').appendChild(positionDD);
      }
      if (showItems) {
        document.getElementById('positionDD').style.display = 'block';
      } else {
        document.getElementById('positionDD').style.display = 'none';
        // positionDD.remove();
      }
    }
  }, [showItems]);

  const useOutsideAlerter = ref => {
    /**
     * Alert if clicked on outside of element
     */
    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        if (showItems) {
          setShowItems(false);
        }
      }
    };
    useEffect(() => {
      setPositionDD(document.getElementById('positionDD'));

      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
        if (positionDD) document.getElementById('positionDD').style.display = 'none';
        // if (positionDD) positionDD.remove();
      };
    });
  };

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const toggleCollapse = () => {
    setShowItems(!showItems);
  };

  return (
    <>
      {isMobile ? (
        <>
          <div className="position mobile">
            <Button title="Position" onMouseDown={toggleCollapse}>
              <span>{t('position')}</span>
            </Button>
          </div>
          {/* {showItems && ( */}
          <div id="positionDD" className="toolsHolder position mobile" ref={wrapperRef}>
            {arrangement && <Arrangement />}
            {alignment && <Alignment />}
          </div>
          {/* )} */}
        </>
      ) : (
          <Dropdown
            title="Position"
            className="text toolsHolder button position"
            text={t('position')}
          >
            <Dropdown.Menu>
              {arrangement && <Arrangement />}
              {alignment && <Alignment />}
            </Dropdown.Menu>
          </Dropdown>
        )}
    </>
  );
};

export default Position;
